import { styled, Box } from '@mui/material'

export const Container = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-around',
  width: '50%',
})
